import script from "./DropdownComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownComponent.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownComponent.vue?vue&type=style&index=0&id=b91aa9d6&lang=scss"

const __exports__ = script;

export default __exports__